import { _ } from "~/route/globals";
import { icon, node } from "~/util/dom";
import { ROUTE_CONST } from "~/route/const";

export default class SummaryClosure {
	_dom: {
		container: HTMLDivElement,
		p: HTMLParagraphElement,
	};

	constructor(routeState, index) {
		this._dom = {
			container: node("div", { className: "route-closure" }),
			p: node("p"),
		};

		this._dom.p.addEventListener("mouseenter", this);
		this._dom.p.addEventListener("mouseleave", this);
		this._build(routeState, index);
	}

	destroy() {
		this._dom.container.remove();
		this._dom.p.removeEventListener("mouseenter", this);
		this._dom.p.removeEventListener("mouseleave", this);
	}

	get container() {
		return this._dom.container;
	}

	_build(routeState, index) {
		let svg = "";
		let count = 0;
		let prevClosure = null;
		let prevWarning = null;

		routeState.items.forEach(item => {
			if (item.closures && item.closures.length && item.closures[index]) {
				count += item.closures[index].length;

				if (prevClosure && item.closures[index].length && prevClosure.source === item.closures[index][0].source && prevClosure.id === item.closures[index][0].id) {
					count -= 1;
				}

				prevClosure = item.closures[index][item.closures[index].length-1];
			}

			if (item.warnings && item.warnings.length && item.warnings[index]) {
				count += item.warnings[index].length;

				if (prevWarning && item.warnings[index].length && prevWarning.source === item.warnings[index][0].source && prevWarning.id === item.warnings[index][0].id) {
					count -= 1;
				}

				prevWarning = item.warnings[index][item.warnings[index].length-1];

				if (prevWarning.type === "via_ferrata") {
					svg = "warning-sign";
				}
			}
		});

		if (svg && count !== 1) {
			switch (routeState.params.type) {
				case ROUTE_CONST.TYPE_CAR:
					svg = "no-entry-car";
					break;

				case ROUTE_CONST.TYPE_BIKE:
					svg = "no-entry-bike";
					break;

				case ROUTE_CONST.TYPE_WALK:
					svg = "no-entry-walk";
					break;

				default:
					//
			}
		}


		if (svg && count > 0) {
			this._dom.p.appendChild(icon(svg));
			this._dom.p.appendChild(node("span", { textContent: _("route.closure.title", { count }) }));

			this._dom.container.appendChild(this._dom.p);
		}
	}

	// eslint-disable-next-line class-methods-use-this
	handleEvent(event: Event) {
		Mapy.CML.state = {
			route: {
				closureHover: event.type === "mouseenter",
			},
		};
	}
}
